import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Avatar,
  Stack,
} from "@mui/material";
import { GridExpandMoreIcon } from "@mui/x-data-grid";

import dayjs from "dayjs";
import { GenericTable } from "../../../../../components/GenericTable/GenericTable";
import { useDatetime } from "../../../../../utils/useDatetime";
import { AllergiesActions } from "./AllergiesActions";
import { useDict } from "../../../../../utils/useDict";
import { useSessionContext } from "../../../../../contexts/SessionContext";

export function Allergies({
  data,
  title,
  openVisualizer,
  verifyVisualizer,
}: any) {
  const { access } = useSessionContext();
  const { formatToDDMMYYYY } = useDatetime;

  const columns = [
    { column: "Subtancia", rowName: "substance" },
    { column: "Categoria", rowName: "category" },
    { column: "Status de verificação", rowName: "verificationStatus" },
    { column: "Status clínico", rowName: "clinicalStatus" },
    { column: "Criticidade", rowName: "criticality" },
    { column: "Data", rowName: "date" },
  ];

  const rowData = data?.[0]?.entry?.map((el: any) => ({
    encounterId: el?.resource?.encounter?.reference?.split("/")?.[1],
    criticality: useDict.criticality[el?.resource?.criticality] || "-",
    category: useDict.category[el?.resource?.category?.[0]] || "-",
    verificationStatus:
      useDict.verificationStatus[
        el?.resource?.verificationStatus?.coding?.[0]?.code
      ] || "",
    clinicalStatus:
      useDict.clinicalStatus[el?.resource?.clinicalStatus?.coding?.[0]?.code] ||
      "",
    substance: el.resource?.code?.text,
    date: formatToDDMMYYYY(dayjs(el?.resource?.recordedDate)),
  }));

  return (
    <Accordion sx={{ width: "100%" }} elevation={5}>
      <AccordionSummary
        expandIcon={<GridExpandMoreIcon />}
        aria-controls="panel1a-content"
        id="panel1a-header"
      >
        <Stack direction="row" alignItems="center" gap={1}>
          {title}
          <Avatar
            sx={{
              width: 26,
              height: 26,
              fontSize: "14px",
              fontWeight: 600,
              backgroundColor: "primary100.main",
              color: "primary1000.main",
            }}
          >
            {rowData?.length || "0"}
          </Avatar>
        </Stack>
      </AccordionSummary>

      <AccordionDetails>
        <GenericTable
          tableColumns={columns}
          tableRows={rowData}
          actions={
            access?.type === "patient"
              ? undefined
              : (rowData: any) => (
                  <AllergiesActions
                    row={rowData}
                    openVisualizer={openVisualizer}
                    verifyVisualizer={verifyVisualizer}
                  />
                )
          }
        />
      </AccordionDetails>
    </Accordion>
  );
}
